import { render } from "./ProssingOne.vue?vue&type=template&id=2acf5855&scoped=true"
import script from "./ProssingOne.vue?vue&type=script&lang=js"
export * from "./ProssingOne.vue?vue&type=script&lang=js"

import "./ProssingOne.vue?vue&type=style&index=0&id=2acf5855&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acf5855"]])

export default __exports__